/* @flow */
function decode(token: string) {
  const contents = token.split('.')[1];
  return contents ? JSON.parse(window.atob(contents)) : {};
}

export default {
  decode,
};



// WEBPACK FOOTER //
// ./src/lib/jsonwebtoken.js